var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.txt.name)+": "+_vm._s(_vm.$keycloak.fullName))]),_c('p',[_vm._v(_vm._s(_vm.txt.username)+": "+_vm._s(_vm.$keycloak.userName))]),_c('p',[_vm._v(_vm._s(_vm.txt.email)+": "+_vm._s(_vm.$keycloak.tokenParsed.email))])])
}
var staticRenderFns = []

export { render, staticRenderFns }